import { Box, Grid, MenuItem, TextField, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Fragment, useEffect, useState } from "react";

import { useAxios } from "../../../hooks";
import List from "../campaign list components/List";
import { PageHeader, Pagination } from "../../../components";
import { CreateButton } from "../../css components/Button";
import { getAllCampaigns } from "../create campaign components/campaign form components/campaignObject";
import pages from "../../../constants/pages";

export default function Campaign() {
  const axios = useAxios();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [campaigns, setCampaigns] = useState([]);
  const [searchKey, setSearchKey] = useState("");
  const options = [5, 10, 25, 50, 100];

  const [page, setPage] = useState({
    page: 1,
    totalCount: 0,
    lastCount: 0,
    itemsPerPage: 10,
  });

  const { activeBrand } = useSelector((state) => state.memberDetails);

  useEffect(() => {
    setLoading(true);
    let url =
      "/user/brand/getCampaignsByBrand/?brandId=" +
      activeBrand.ID +
      `&page=${page.page}&limit=${page.itemsPerPage}` +
      (searchKey ? `&search=${encodeURIComponent(searchKey)}` : "");

    axios({
      url: url,
    }).then((response) => {
      if (response.status) {
        setCampaigns(getAllCampaigns(response, activeBrand));

        setPage((prev) => ({
          ...prev,
          totalCount: response.data.totalCounts,
          lastPage: response.data.campaignData.length < 10,
        }));
      }
      setLoading(false);
    });
  }, [
    axios,
    activeBrand.ID,
    activeBrand,
    searchKey,
    page.page,
    page.itemsPerPage,
  ]);

  function handlePagination(step, index) {
    setPage((prev) => ({
      ...prev,
      page: step === "index" ? index : prev + (step === "next" ? 1 : -1),
    }));
  }

  const handleChange = (event) => {
    setPage((prev) => ({
      ...prev,
      itemsPerPage: event.target.value,
    }));
  };

  return (
    <Fragment>
      <PageHeader
        pageName={"Campaigns"}
        pageHeader="View and manage all your campaigns in one place."
        buttons={[
          <CreateButton
            variant="contained"
            onClick={() => navigate(pages.createCampaign.route)}
          >
            Create New Campaign
          </CreateButton>,
        ]}
      />

      <List
        loading={loading}
        setPage={setPage}
        setSearchKey={setSearchKey}
        campaigns={campaigns}
        component=""
      />

      {!!page.totalCount && (
        <Grid item container display={"flex"} justifyContent={"space-between"}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
            }}
          >
            <Typography variant="body1" fontWeight={600}>
              Items per page:
            </Typography>
            <TextField
              select
              size="small"
              value={page.itemsPerPage}
              onChange={handleChange}
              sx={{
                width: 80,
                "& .MuiOutlinedInput-input": {
                  textAlign: "center",
                },
              }}
            >
              {options.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </TextField>
          </Box>

          <Pagination
            style={{ marginTop: "20px" }}
            count={Math.ceil(page.totalCount / 10)}
            variant="outlined"
            color="secondary"
            page={page.page}
            onChange={(e, value) => handlePagination("index", value)}
          />
        </Grid>
      )}
    </Fragment>
  );
}
